import React from 'react';
import classnames from 'classnames';

const Tag = ({ value, theme }) => {
	const cls = classnames(
		'inline-block px-2.5 h-7 text-sm text-center leading-7 rounded-full font-semibold',
		!theme && 'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-100',
		theme === 'success' && 'bg-emerald-500 text-white',
		theme === 'warning' && 'bg-sky-500 text-white',
		theme === 'danger' && 'bg-rose-500 text-white',
	);
	
	return (
		<div className={cls}>
			{value}
		</div>
	);
};

export default Tag;